var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});
var semanticAttributes = require('../semanticAttributes.js');

/**
 * Converts a transaction event to a span JSON object.
 */
function convertTransactionEventToSpanJson(event) {
  var _event$contexts$trace, _event$contexts, _event$start_timestam;
  var _ref = (_event$contexts$trace = (_event$contexts = event.contexts) === null || _event$contexts === void 0 ? void 0 : _event$contexts.trace) !== null && _event$contexts$trace !== void 0 ? _event$contexts$trace : {},
    trace_id = _ref.trace_id,
    parent_span_id = _ref.parent_span_id,
    span_id = _ref.span_id,
    status = _ref.status,
    origin = _ref.origin,
    data = _ref.data,
    op = _ref.op;
  return {
    data: data !== null && data !== void 0 ? data : {},
    description: event.transaction,
    op: op,
    parent_span_id: parent_span_id,
    span_id: span_id !== null && span_id !== void 0 ? span_id : '',
    start_timestamp: (_event$start_timestam = event.start_timestamp) !== null && _event$start_timestam !== void 0 ? _event$start_timestam : 0,
    status: status,
    timestamp: event.timestamp,
    trace_id: trace_id !== null && trace_id !== void 0 ? trace_id : '',
    origin: origin,
    profile_id: data === null || data === void 0 ? void 0 : data[semanticAttributes.SEMANTIC_ATTRIBUTE_PROFILE_ID],
    exclusive_time: data === null || data === void 0 ? void 0 : data[semanticAttributes.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
    measurements: event.measurements,
    is_segment: true
  };
}

/**
 * Converts a span JSON object to a transaction event.
 */
function convertSpanJsonToTransactionEvent(span) {
  return {
    type: 'transaction',
    timestamp: span.timestamp,
    start_timestamp: span.start_timestamp,
    transaction: span.description,
    contexts: {
      trace: {
        trace_id: span.trace_id,
        span_id: span.span_id,
        parent_span_id: span.parent_span_id,
        op: span.op,
        status: span.status,
        origin: span.origin,
        data: _objectSpread(_objectSpread(_objectSpread({}, span.data), span.profile_id && _defineProperty({}, semanticAttributes.SEMANTIC_ATTRIBUTE_PROFILE_ID, span.profile_id)), span.exclusive_time && _defineProperty({}, semanticAttributes.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME, span.exclusive_time))
      }
    },
    measurements: span.measurements
  };
}
exports.convertSpanJsonToTransactionEvent = convertSpanJsonToTransactionEvent;
exports.convertTransactionEventToSpanJson = convertTransactionEventToSpanJson;